import salesAssistantAPI from '@shared/api/salesAssistant'

export default function useSalesAssistant() {
  async function getInsurers() {
    const data = await salesAssistantAPI.getInsurers()

    return data.sort((a, b) => {
      const _a = a.toUpperCase()
      const _b = b.toUpperCase()

      if (_a < _b) {
        return -1
      } else if (_a > _b) {
        return 1
      } else {
        return 0
      }
    })
  }

  async function getInsurerProducts({ insurer, language, insuranceType}) {
    const products = await salesAssistantAPI.getInsurerProducts({
      insurer, language
    })
    return products.filter(product => product.insuranceType === insuranceType)
  }

  async function mapProducts(payload, passthrough) {
    return await salesAssistantAPI.mapProducts(payload, passthrough)
  }

  async function uploadPolicy(file, passthrough = ['COMPETITOR_POLICY_EXTRACTION_NOT_POSSIBLE']) {
    return await salesAssistantAPI.uploadPolicy(file, passthrough)
  }

  return {
    getInsurers,
    getInsurerProducts,
    mapProducts,
    uploadPolicy,
  }
}